import { Input } from '@ui/themed';
import { t } from 'i18next';
import { CUSTOMER_GROUP_NAME_MAX_LENGTH } from '../../constants';
import { useCustomerGroupsQuickSetupForm } from '../../hooks/use-customer-groups-quick-setup-form';

export function NameField() {
  const form = useCustomerGroupsQuickSetupForm();

  return (
    <form.Field name="name">
      {(field) => (
        <Input
          label={t('features:customer_group.components.quick_setup.name.label')}
          placeholder={t('features:customer_group.components.quick_setup.name.placeholder')}
          value={field.state.value}
          onChange={field.handleChange}
          error={field.state.meta.errors[0]?.message}
          maxLength={CUSTOMER_GROUP_NAME_MAX_LENGTH}
        />
      )}
    </form.Field>
  );
}
